import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CancelIcon from "@material-ui/icons/Cancel";

const DeleteOrderUnitIcon = ({ onClick, tooltipText, className }) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip">{tooltipText}</Tooltip>}
    >
      <CancelIcon
        cursor="pointer"
        fontSize="large"
        onClick={onClick}
        className={className}
      />
    </OverlayTrigger>
  );
};

export default DeleteOrderUnitIcon;
